export const listTourSelectorsFactory = (
  removeItemButtonAriaLabel: string,
  pasteTextIntoFieldButtonAriaLabel: string,
  accordionToggleButtonAriaLabel: string,
) => {
  const getLastCardElement = () =>
    [...document.querySelectorAll(`[aria-label="${removeItemButtonAriaLabel}"]`)].at(-1)?.closest('li')

  return {
    getAddMethodsRow: () =>
      document.querySelector<HTMLElement>(`[aria-label="${pasteTextIntoFieldButtonAriaLabel}"]`)?.parentElement
        ?.parentElement,

    getExpandIcon: () => {
      const lastCardElement = getLastCardElement()
      if (!lastCardElement) return null

      return lastCardElement.querySelector<HTMLButtonElement>(`button[aria-label="${accordionToggleButtonAriaLabel}"]`)
    },

    getFieldInLastCard: (ariaLabel: string) => () => {
      const lastCardElement = getLastCardElement()
      if (!lastCardElement) return null

      return lastCardElement.querySelector<HTMLElement>(`[aria-label="${ariaLabel}"]`)
    },
  }
}
